// Gom 5 việc hằng ngày của CSKH thành MỘT nhóm menu đứng đầu — chỉ cho nhân sự
// phòng CSKH (CEO chốt 09/10/2026, câu 6a của bản rà soát vòng đời CSKH).
//
// Vì sao cần (đo 09/10/2026): nhân viên CSKH thấy 23 mục trong 8 nhóm; 5 việc
// làm mỗi ngày nằm rải ở 2 nhóm, "Booking online" là thẻ đầu của trang Chăm sóc
// khách nhưng lại là mục cuối nhóm.
//
// Cùng nếp với `reception-daily-group.ts`: SẮP XẾP LÚC CHẠY, không sửa
// NAV_GROUPS. Vai khác nhận lại đúng mảng cũ; mục chưa được gom vẫn ở nhóm cũ.
import type { NavGroup } from "./nav-items";
import { leadGroupOf } from "./reception-daily-group";

/**
 * Xếp theo NGÀY LÀM VIỆC của CSKH: trả lời khách đang chờ → nhận lịch khách tự
 * đặt → sổ sửa hình → khiếu nại → đơn in và bán thêm.
 *
 * Mục nào người xem không được cấp quyền thì tự khuyết — hàm chỉ SẮP XẾP LẠI
 * những mục đã qua bộ lọc quyền, không mở thêm cửa nào.
 */
export const CSKH_DAILY_ITEM_IDS = [
  "customer_chats",
  "cskh_booking",
  "cskh_retouch",
  "complaints",
  "cskh_upsale",
] as const;

export const CSKH_DAILY_GROUP = { id: "cskh_daily", label: "Việc hằng ngày" } as const;

export function groupDailyForCskh(groups: NavGroup[], isCskhDesk: boolean): NavGroup[] {
  if (!isCskhDesk) return groups;
  return leadGroupOf(groups, CSKH_DAILY_ITEM_IDS, CSKH_DAILY_GROUP);
}
